var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconXx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0.0000293 378.2504272 378.2508545",
    enableBackground: "new 0 0.0000293 378.2504272 378.2508545",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#3C3C3C",
    d: "M370.8095703,334.8450317L224.470047,188.5055237L370.8095703,43.4058533 c9.9212036-11.1614227,8.6813354-27.2838192,0-35.9647598c-4.9605713-4.9605913-11.1614075-7.4410763-18.6025085-7.4410763 c-7.4410706,0-13.6419067,2.480485-17.3622437,7.4410763L189.7451477,152.5407562L43.4056282,7.4410944 c-4.9605904-4.9605913-11.1614265-7.4410763-18.6025009-7.4410763S11.1612167,2.4805031,7.4408679,7.4410944 c-9.9211826,11.1614256-9.9211826,27.2838211,0,35.9647598l145.0996552,145.0996704L7.4408679,334.8450317 c-9.9211826,11.161438-9.9211826,27.283844,0,35.9647827c4.9605908,4.9605713,11.1614246,7.4410706,17.3622589,7.4410706 c7.4410744,0,12.4016685-2.4804993,17.3622589-7.4410706l146.3395233-146.3395386l146.3395386,146.3395386 c4.9605713,4.9605713,11.1614075,7.4410706,17.3622437,7.4410706s13.6419067-2.4804993,18.6025085-7.4410706 C380.7307739,360.8886108,380.7307739,343.5263672,370.8095703,334.8450317z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXx);
export default __webpack_public_path__ + "static/media/icon_xx.4e9e3dda1ccda1f93302de6739c9d1a5.svg";
export { ForwardRef as ReactComponent };